import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown} from 'semantic-ui-react';
import {returnAcceptanceTypes} from '../../../common/dictionaries/parameters';
import {Actions} from '../../../common/actions';

const parseOptions = () => {
  return Object.keys(returnAcceptanceTypes).map((acceptanceType) => {
    return {'text': returnAcceptanceTypes[acceptanceType], 'value': acceptanceType};
  });
};

class AcceptanceReason extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, data) {
    const {claimCode} = this.props;
    this.props.updateReturnOrderValue(claimCode, data);
  }

  render() {
    const {isUserFromTDE, returnOrder, value} = this.props;

    if (isUserFromTDE && returnOrder.status === 'E') {
      return (
        <Dropdown selection
          name='acceptanceReason'
          value={value || ''}
          options={parseOptions()}
          onChange={this.handleChange}
        />
      );
    }

    if (!value) {
      return null;
    }
    
    return returnAcceptanceTypes[value];
  }
}

const mapStateToProps = (state) => {
  return {
    'isUserFromTDE': state.session.isUserFromTDE,
    'returnOrder': state.partsReturnsOrders.selectedOrder,
  };
};

const {updateReturnOrderValue} = Actions;

export default connect(mapStateToProps, {
  updateReturnOrderValue,
})(AcceptanceReason);
